export enum ComplianceError {
  InvalidAddress = 'InvalidAddress',
}
